<div class="error-box-container">
    <img [class.verySmall]="verySmall" [class.small]="isMobile" src="/assets/images/error-for-box.svg" />
    <p class="veryVerySmall" [class.white]="white">{{ "errorBox.firstParagraph" | translate }}</p>
    <p *ngIf="contactSupport" (click)="openIntercom()" class="veryVerySmall link">{{ "errorBox.secondParagraph" | translate }}</p>
    <p *ngIf="!contactSupport" (click)="tryAgain()" class="veryVerySmall link">{{ "errorBox.thirdParagraph" | translate }}</p>
</div>
